import * as React from "react";
import PropTypes from "prop-types";
import Theme from "../Theme";
import prefixStyles from "../utils/prefixStyles";
import NoStyleButton from "../NoStyleButton";
import Tappable from "../Tappable";

const baseStyle = prefixStyles({
  backgroundColor: "black",
  transition: "opacity 250ms",
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0, // NoStyleButton version needs this in Safari or it slides right to its sibling (https://developers.google.com/web/updates/2016/06/absolute-positioned-children)
  width: "100%", // NoStyleButton version needs this instead of "right" in Chrome or it has no width (no one else on the internet has this issue)
  zIndex: Theme.zIndexLayers.MODAL,
});

class DialogBackground extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    style: PropTypes.object,
    onTap: PropTypes.func,
  };

  state = {
    opacity: 0,
  };

  componentDidMount() {
    this._isMounted = true;
    if (this.props.open) {
      requestAnimationFrame(() => {
        if (this._isMounted && this.props.open) {
          this.setState({
            opacity: 0.5,
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({
        opacity: nextProps.open ? 0.5 : 0,
      });
    }
  }

  render() {
    const { open, style, onTap, ...rest } = this.props;
    const { opacity } = this.state;

    const combinedStyle = {
      ...baseStyle,
      opacity,
      ...(open ? null : { pointerEvents: "none" }),
      ...style,
    };

    return (
      <Tappable onTap={onTap}>
        {({ tapTargetRefHandler }) => {
          return onTap ? (
            <NoStyleButton
              innerRef={tapTargetRefHandler}
              style={combinedStyle}
              {...rest}
            /> // use NoStyleButton for screen readers
          ) : (
            <div style={combinedStyle} {...rest} />
          );
        }}
      </Tappable>
    );
  }
}

export default DialogBackground;



// WEBPACK FOOTER //
// ../nx-components/src/Dialog/DialogBackground.jsx